<template>
  <!--
    Komponent wyświetlający zakres dat jako filtr.
    Pokazuje wybrane daty rozpoczęcia i zakończenia w czytelnej formie.
    Użytkownik może usunąć filtr za pomocą ikony kosza.
  -->
  <div
    v-if="store.filters.dateTimeStart || store.filters.dateTimeEnd"
    class="filter d-flex flex-column"
  >
    <!--
      Nagłówek sekcji z etykietą 'Data' oraz ikoną usuwania filtra.
    -->
    <h5>
      {{ t('date') }}
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!--
      Sekcja wyświetlająca szczegóły filtra:
      - data początkowa (jeśli istnieje)
      - data końcowa (jeśli istnieje)
    -->
    <div class="info collapse show" id="dateRange">
      <!-- Wyświetlenie daty początkowej -->
      <p v-if="store.filters.dateTimeStart" class="margin-0">
        {{ t('from') }}: {{ formatDate(store.filters.dateTimeStart) }}
      </p>
      <!-- Wyświetlenie daty końcowej -->
      <p v-if="store.filters.dateTimeEnd" class="margin-0">
        {{ t('to') }}: {{ formatDate(store.filters.dateTimeEnd) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateRangeFilterView",  // Nazwa komponentu
  props: {
    store: { required: true },   // Pinia store zawierający filtry zakresu dat
  },
  methods: {
    /**
     * Usuwa filtr daty (czyści zarówno dateTimeStart, jak i dateTimeEnd)
     */
    removeFilter() {
      this.store.removeItem("rangeOfDate");
    },
    /**
     * Formatuje ciąg daty ISO na czytelny format lokalny
     * @param {string} dateString - data w formacie ISO
     * @returns {string} Sformatowana data i godzina
     */
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      };
      return new Intl.DateTimeFormat("default", options).format(date);
    },
  },
};
</script>

<style scoped>
.filter {
  width: 100%;  /* Pełna szerokość kontenera */
}

/* Styl nagłówka sekcji */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Sekcja z informacjami o filtrze */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
}

/* Ikona kosza do usuwania filtra */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}

/* Ikona rozwijania/zwijania (zakomentowana) */
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
